// StatusBadge.tsx — feedback status pill. Pure component.
import styled from 'styled-components';
import type { FeedbackStatus } from '@/core/models/feedback';
import { FEEDBACK_STATUS_LABELS } from '@/core/models/feedback';
import { STATUS_TONES } from './feedbackMeta';

type Tone = (typeof STATUS_TONES)[FeedbackStatus];

const Pill = styled.span<{ $tone: Tone }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: ${({ theme }) => theme.radius.sm};
  white-space: nowrap;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: 600;
  color: ${({ theme, $tone }) =>
    $tone === 'good'
      ? theme.color.success
      : $tone === 'muted'
        ? theme.color.textMuted
        : $tone === 'accent'
          ? theme.color.brandFrom
          : $tone === 'info'
            ? theme.color.accentCyan
            : theme.color.textPrimary};
  background: ${({ theme, $tone }) =>
    $tone === 'good'
      ? `${theme.color.success}22`
      : $tone === 'accent'
        ? `${theme.color.brandFrom}22`
        : $tone === 'info'
          ? `${theme.color.accentCyan}22`
          : theme.color.glassBg};
  border: 1px solid
    ${({ theme, $tone }) =>
      $tone === 'muted' || $tone === 'neutral' ? theme.color.glassBorder : 'transparent'};
`;

export interface StatusBadgeProps {
  status: FeedbackStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <Pill $tone={STATUS_TONES[status]} data-testid={`status-${status}`}>
      {FEEDBACK_STATUS_LABELS[status]}
    </Pill>
  );
}
